import { createSlice } from "@reduxjs/toolkit";
import { generateUUID } from "utils/common";

const initialState = {
  createNewSite: {
    searchMqProjects: {
      searchMqProjectsFields: {
        projectSearch: "",
        projectType: { id: "project-type-all", label: "All", description: "All" },
        userEmail: "",
      },
      showMqProjectSearchTable: false,
      searchMqProjectsResults: [],
      filteredMqProjects: [],
      isSearchOtherUser: false,
    },
    siteDetails: {
      accountNumber: "",
      accountName: "",
      parentNumber: "",
      parentName: "",
      accountPhoneNumber: "",
      execNumber: "",
      execName: "",
      customerName: "",
      contactName: "",
      accountCity: "",
      accountPhone: "",
      accountStreet: "",
      accountZip: "",
      siteName: "",
      siteAddress: "",
      siteState: "",
      siteCity: "",
      siteZip: "",
      siteStreet: "",
      territory: "",
      laborTaxIndicator: "",
    },
    selectedData: {
      projects: [],
      isSelectAll: false,
    },
  },
  viewSite: {
    projectDetailsList: [],
  },
  editSite: {
    searchMqProjects: {
      searchMqProjectsFields: {
        projectSearch: "",
        projectType: { id: "project-type-all", label: "All", description: "All" },
        userEmail: "",
      },
      showMqProjectSearchTable: false,
      searchMqProjectsResults: [],
      filteredMqProjects: [],
      isSearchOtherUser: false,
    },
    selectedData: {
      projects: [],
      isSelectAll: false,
    },
  },
  search: {
    siteName: "",
    accountNumber: "",
    accountName: "",
    phoneNumber: "",
    city: "",
    state: "",
    siteId: "",
    isShowTable: false,
    results: [],
    searchFilterValue: "",
  },
  distinctLaborCodes: [],
  allSiteNames: [],
  rerunBulkUpdateData: [],
  showBulkUpdateModal: false,
  stores: {},
};

const siteRepo = createSlice({
  name: "siteRepo",
  initialState,
  reducers: {
    confirmBulkUpdateModal(state, action) {
      state.showBulkUpdateModal = action.payload;
    },
    searchMqProjects(state) {
      state.createNewSite.searchMqProjects.showMqProjectSearchTable = false;
    },
    searchMqProjectsForEdit(state) {
      state.editSite.showMqProjectSearchTable = false;
    },
    searchMqProjectsSucess(state, action) {
      const searchKeyWord = action.payload.searchFields.projectSearch;
      const searchFilter = action.payload.searchFields.projectType;
      let filterIndex = 0;
      let projectIndex = 0;
      let searchResults = action.payload.res.filter((projectItem) => {
        if (new RegExp(searchKeyWord.toLowerCase()).test(projectItem.name.toLowerCase())) {
          projectItem.isSelected = false;
          projectItem.isExpanded = false;
          projectItem.isActionMenuOpen = false;
          projectItem.elementIndex = projectIndex;
          projectItem.layersInfo = [];
          projectItem.domId = generateUUID();
          filterIndex = filterIndex + 1;

          if (searchFilter.id === "project-type-my-projects") {
            if (projectItem.isArchived == "false") {
              projectIndex += 1;
            }
            return projectItem.isArchived == "false";
          } else if (searchFilter.id === "project-type-archived") {
            if (projectItem.isArchived == "true") {
              projectIndex += 1;
            }
            return projectItem.isArchived == "true";
          } else if (searchFilter.id === "project-type-all") {
            projectIndex += 1;
            return true;
          } else {
            return false;
          }
        }
      });

      state.createNewSite.searchMqProjects.searchMqProjectsResults = [...searchResults];
      state.createNewSite.searchMqProjects.showMqProjectSearchTable = true;
      state.createNewSite.selectedData.projects = [];
      state.createNewSite.selectedData.isSelectAll = false;
    },
    searchMqProjectForEditSuccess(state, action) {
      const searchKeyWord = action.payload.searchFields.projectSearch;
      const searchFilter = action.payload.searchFields.projectType;
      let searchResults;
      let filterIndex = 0;
      let projectIndex = 0;
      searchResults = action.payload.res.filter((projectItem) => {
        if (new RegExp(searchKeyWord.toLowerCase()).test(projectItem.name.toLowerCase())) {
          projectItem.isSelected = false;
          projectItem.isExpanded = false;
          projectItem.isActionMenuOpen = false;
          projectItem.elementIndex = projectIndex;
          projectItem.layersInfo = [];
          projectItem.domId = generateUUID();
          filterIndex = filterIndex + 1;

          if (searchFilter.id === "project-type-my-projects") {
            if (projectItem.isArchived == "false") {
              projectIndex += 1;
            }
            return projectItem.isArchived == "false";
          } else if (searchFilter.id === "project-type-archived") {
            if (projectItem.isArchived == "true") {
              projectIndex += 1;
            }
            return projectItem.isArchived == "true";
          } else if (searchFilter.id === "project-type-all") {
            projectIndex += 1;
            return true;
          } else {
            return false;
          }
        }
      });

      state.editSite.searchMqProjects.searchMqProjectsResults = [...searchResults];
      state.editSite.searchMqProjects.showMqProjectSearchTable = true;
      state.editSite.selectedData.projects = [];
      state.editSite.selectedData.isSelectAll = false;
    },
    searchIsLoggedInUser(state, action) {
      const { isLoggedInUserSearch, isEdit } = action.payload;
      if (isEdit) {
        state.editSite.searchMqProjects.isSearchOtherUser = isLoggedInUserSearch;
      } else {
        state.createNewSite.searchMqProjects.isSearchOtherUser = isLoggedInUserSearch;
      }
    },
    updateMqSearchProjectFields(state, action) {
      const { key, value, isEdit } = action.payload;
      let updatedValue = value;

      if (key === "projectType") {
        if (!value?.id) {
          updatedValue = isEdit
            ? initialState.editSite.searchMqProjects.searchMqProjectsFields[key]
            : initialState.createNewSite.searchMqProjects.searchMqProjectsFields[key];
        } else {
          updatedValue = { ...value };
        }
      }

      if (isEdit) {
        state.editSite.searchMqProjects.searchMqProjectsFields[key] = updatedValue;
      } else {
        state.createNewSite.searchMqProjects.searchMqProjectsFields[key] = updatedValue;
      }
    },
    getRoomsInfoByMqProjectSuccess(state, action) {
      const { res, index, isEdit } = action.payload;
      res.forEach((layer, index) => {
        layer.isSelected = false;
        layer.elementIndex = index;
        layer.pictureData = null;
      });

      const tempSearchMqProjectsValue = JSON.parse(
        JSON.stringify(state[isEdit ? "editSite" : "createNewSite"].searchMqProjects.searchMqProjectsResults),
      );
      tempSearchMqProjectsValue[index].layersInfo = [...res];
      if (isEdit) {
        state.editSite.searchMqProjects.searchMqProjectsResults = [...tempSearchMqProjectsValue];
      } else {
        state.createNewSite.searchMqProjects.searchMqProjectsResults = [...tempSearchMqProjectsValue];
      }
    },
    setImageData(state, action) {
      const { res, isEdit } = action.payload;
      const siteSearchStateClone = JSON.parse(
        JSON.stringify(state[isEdit ? "editSite" : "createNewSite"].searchMqProjects.searchMqProjectsResults),
      );
      const selectedProjectsStateClone = JSON.parse(
        JSON.stringify(state[isEdit ? "editSite" : "createNewSite"].selectedData.projects),
      );
      res.map((project) => {
        project.layersInfo?.map((layer) => {
          siteSearchStateClone[project.elementIndex].layersInfo[layer.value.elementIndex].pictureData =
            layer.value.pictureData;
        });
        selectedProjectsStateClone.some((selectedProject) => {
          if (selectedProject.domId === project.domId) {
            project.layersInfo?.map((layer) => {
              selectedProject.layersInfo[layer.value.elementIndex].pictureData = layer.value.pictureData;
            });
            return true;
          }
        });
      });
      if (isEdit) {
        state.editSite.searchMqProjects.searchMqProjectsResults = [...siteSearchStateClone];
        state.editSite.selectedData.projects = [...selectedProjectsStateClone];
      } else {
        state.createNewSite.searchMqProjects.searchMqProjectsResults = [...siteSearchStateClone];
        state.createNewSite.selectedData.projects = [...selectedProjectsStateClone];
      }
    },
    updateSelectLayer(state, action) {
      const { selectLayerProjectIndex, selectLayerLayerIndex, isEdit } = action.payload;
      const tempSelectLayerValue = JSON.parse(
        JSON.stringify(state[isEdit ? "editSite" : "createNewSite"].searchMqProjects.searchMqProjectsResults),
      );
      const tempSelectLayerSelectedDataValue = JSON.parse(
        JSON.stringify(state[isEdit ? "editSite" : "createNewSite"].selectedData),
      );

      tempSelectLayerSelectedDataValue.isSelectAll = false;
      tempSelectLayerValue[selectLayerProjectIndex].layersInfo[selectLayerLayerIndex].isSelected =
        !tempSelectLayerValue[selectLayerProjectIndex].layersInfo[selectLayerLayerIndex].isSelected;
      const isAnyLayersSelected = tempSelectLayerValue[selectLayerProjectIndex].layersInfo.some(
        (layer) => layer.isSelected,
      );
      if (isAnyLayersSelected !== tempSelectLayerValue[selectLayerProjectIndex].isSelected) {
        tempSelectLayerValue[selectLayerProjectIndex].isSelected = isAnyLayersSelected;
        if (isAnyLayersSelected) {
          tempSelectLayerSelectedDataValue.projects.push(tempSelectLayerValue[selectLayerProjectIndex]);
        } else {
          tempSelectLayerSelectedDataValue.projects.some((projectElement, index) => {
            if (projectElement.domId === tempSelectLayerValue[selectLayerProjectIndex].domId) {
              tempSelectLayerSelectedDataValue.projects.splice(index, 1);
            }
            return projectElement.domId === tempSelectLayerValue[selectLayerProjectIndex].domId;
          });
        }
      } else {
        tempSelectLayerSelectedDataValue.projects.some((projectElement) => {
          if (projectElement.domId === tempSelectLayerValue[selectLayerProjectIndex].domId) {
            projectElement.layersInfo.some((layer) => {
              if (
                layer.elementIndex ==
                tempSelectLayerValue[selectLayerProjectIndex].layersInfo[selectLayerLayerIndex].elementIndex
              ) {
                layer.isSelected =
                  tempSelectLayerValue[selectLayerProjectIndex].layersInfo[selectLayerLayerIndex].isSelected;
              }
              return (
                layer.elementIndex ==
                tempSelectLayerValue[selectLayerProjectIndex].layersInfo[selectLayerLayerIndex].elementIndex
              );
            });
          }
          return projectElement.domId === tempSelectLayerValue[selectLayerProjectIndex].domId;
        });
      }

      if (isEdit) {
        state.editSite.searchMqProjects.searchMqProjectsResults = [...tempSelectLayerValue];
        state.editSite.selectedData = { ...tempSelectLayerSelectedDataValue };
      } else {
        state.createNewSite.searchMqProjects.searchMqProjectsResults = [...tempSelectLayerValue];
        state.createNewSite.selectedData = { ...tempSelectLayerSelectedDataValue };
      }
    },
    updateSelectProject(state, action) {
      const { selectProjectIndex, isEdit } = action.payload;
      const tempSelectProjectValue = JSON.parse(
        JSON.stringify(state[isEdit ? "editSite" : "createNewSite"].searchMqProjects.searchMqProjectsResults),
      );
      const tempSelectProjectSelectedDataValue = JSON.parse(
        JSON.stringify(state[isEdit ? "editSite" : "createNewSite"].selectedData),
      );
      tempSelectProjectSelectedDataValue.isSelectAll = false;
      tempSelectProjectValue[selectProjectIndex].isSelected = !tempSelectProjectValue[selectProjectIndex].isSelected;
      if (tempSelectProjectValue[selectProjectIndex].isSelected) {
        tempSelectProjectSelectedDataValue.projects.push(tempSelectProjectValue[selectProjectIndex]);
      } else {
        tempSelectProjectSelectedDataValue.projects.some((projectElement, index) => {
          if (projectElement.domId === tempSelectProjectValue[selectProjectIndex].domId) {
            tempSelectProjectSelectedDataValue.projects.splice(index, 1);
          }
          return projectElement.domId === tempSelectProjectValue[selectProjectIndex].domId;
        });
      }
      tempSelectProjectValue[selectProjectIndex].layersInfo.map(
        (layer) => (layer.isSelected = tempSelectProjectValue[selectProjectIndex].isSelected),
      );

      if (isEdit) {
        state.editSite.searchMqProjects.searchMqProjectsResults = [...tempSelectProjectValue];
        state.editSite.selectedData = { ...tempSelectProjectSelectedDataValue };
      } else {
        state.createNewSite.searchMqProjects.searchMqProjectsResults = [...tempSelectProjectValue];
        state.createNewSite.selectedData = { ...tempSelectProjectSelectedDataValue };
      }
    },
    updateSelectAllProjects(state, action) {
      const { projectsArray, isChecked, isEdit } = action.payload;
      const projectsArrayClone = projectsArray.length ? JSON.parse(JSON.stringify(projectsArray)) : [];
      const tempSelectAllProjectValue = JSON.parse(
        JSON.stringify(state[isEdit ? "editSite" : "createNewSite"].searchMqProjects.searchMqProjectsResults),
      );
      const tempSelectAllProjectSelectedDataValue = JSON.parse(
        JSON.stringify(state[isEdit ? "editSite" : "createNewSite"].selectedData),
      );
      if (isChecked) {
        tempSelectAllProjectSelectedDataValue.projects.map((project) => {
          tempSelectAllProjectValue[project.elementIndex].isSelected = false;
          tempSelectAllProjectValue[project.elementIndex].layersInfo.map((layer) => (layer.isSelected = false));
        });
        if (!isEdit) {
          state.createNewSite.searchMqProjects.searchMqProjectsResults = [...tempSelectAllProjectValue];
          state.createNewSite.selectedData.projects = [];
          state.createNewSite.selectedData.isSelectAll = false;
        } else {
          state.editSite.searchMqProjects.searchMqProjectsResults = [...tempSelectAllProjectValue];
          state.editSite.selectedData.projects = [];
          state.editSite.selectedData.isSelectAll = false;
        }
      } else {
        const selectedProjects = projectsArrayClone.map((project) => {
          project.value.isSelected = true;
          project.value.layersInfo.map((layer) => (layer.isSelected = true));
          tempSelectAllProjectValue[project.value.elementIndex] = project.value;
          return project.value;
        });

        if (isEdit) {
          state.editSite.searchMqProjects.searchMqProjectsResults = [...tempSelectAllProjectValue];
          state.editSite.selectedData.projects = [...selectedProjects];
          state.editSite.selectedData.isSelectAll = true;
        } else {
          state.createNewSite.searchMqProjects.searchMqProjectsResults = [...tempSelectAllProjectValue];
          state.createNewSite.selectedData.projects = [...selectedProjects];
          state.createNewSite.selectedData.isSelectAll = true;
        }
      }
    },
    updateSiteDetailsFields(state, action) {
      state.createNewSite.siteDetails[action.payload.key] = action.payload.value;
    },
    updateEditSiteDetailsFields(state, action) {
      state.editSite[action.payload.key] = action.payload.value;
    },
    submitCreateSite(state, action) {
      state.createNewSite = { ...initialState.createNewSite };
      state.editSite = { ...initialState.editSite };
      state.viewSite = action?.payload?.viewSiteObj ?? {};
      state.search = { ...initialState.search };
    },
    searchSites(state) {
      state.search.isShowTable = false;
    },
    updateSiteSearchFields(state, action) {
      state.search[action.payload.key] = action.payload.value;
    },
    searchSitesSuccess(state, action) {
      state.search.results = action.payload;
      state.search.isShowTable = true;
    },
    clearSiteSearchFields(state) {
      state.search = { ...initialState.search };
    },
    clearSiteFields(state) {
      state.createNewSite = { ...initialState.createNewSite };
    },
    setSiteData(state, action) {
      state.viewSite = {
        ...state.viewSite,
        ...action.payload,
        projectDetailsList: (action.payload?.projectDetailsList ?? [])
          .filter((proj) => proj.layerInfoList.length > 0)
          .map((proj) => ({
            ...state.viewSite?.projectDetailsList?.find(({ projectId }) => proj.projectId === projectId),
            ...proj,
          })),
      };
    },
    setEditSiteData(state, action) {
      state.editSite = { ...state.editSite, ...action.payload };
    },
    removeLayer(state, action) {
      const { projectId, layerId, isView } = action.payload;
      let projectListClone;
      let projectIndexValue;
      let layerIndexValue;
      if (!isView) {
        projectListClone = JSON.parse(JSON.stringify(state.editSite.projectDetailsList));

        projectListClone.forEach((project, projectIndex) => {
          if (project.projectId === projectId) {
            projectIndexValue = projectIndex;
            project.layerInfoList.forEach((layer, layerIndex) => {
              if (layer.layerId === layerId) {
                layerIndexValue = layerIndex;
              }
            });
          }
        });

        projectListClone[projectIndexValue].layerInfoList.splice(layerIndexValue, 1);

        if (projectListClone[projectIndexValue].layerInfoList?.length === 0) {
          projectListClone.splice(projectIndexValue, 1);
        }
      }

      const viewSiteProjectListClone = JSON.parse(JSON.stringify(state.viewSite.projectDetailsList));

      viewSiteProjectListClone.forEach((project, prjIdx) => {
        if (project.projectId === projectId) {
          project.layerInfoList?.forEach((layer, index) => {
            if (layer.layerId === layerId) {
              project.layerInfoList.splice(index, 1);

              if (project.layerInfoList.length === 0) {
                viewSiteProjectListClone.splice(prjIdx, 1);
              }
            }
          });
        }
      });

      state.viewSite.projectDetailsList = viewSiteProjectListClone;
      state.editSite.projectDetailsList = projectListClone ? [...projectListClone] : [];
    },
    resetEditSiteData(state) {
      state.editSite = { ...initialState.editSite };
    },
    getLaborCodeList(state, action) {
      state.distinctLaborCodes = action.payload;
    },
    getAllSiteNames(state, action) {
      state.allSiteNames = action.payload;
    },
    setRerunBulkUpdateData(state, action) {
      state.rerunBulkUpdateData = action.payload;
    },
    loadStoreLaborCodes(state, action) {
      const { storeNumber, laborCodes } = action.payload;
      state.stores[storeNumber] = { laborCodes };
    },
    editSiteProductLaborCode(state, action) {
      state.viewSite.projectDetailsList = state.viewSite.projectDetailsList.map((project) => ({
        ...project,
        layerInfoList: project.layerInfoList.map((layer) => ({
          ...layer,
          rooms: layer.rooms.map((room) => ({
            ...room,
            products: room.products.map((product) => ({
              ...product,
              siteLaborCodes: product.siteLaborCodes.map((laborCode) => {
                return action.payload.siteLaborCodeIds.includes(laborCode.siteLaborCodeId)
                  ? { ...laborCode, ...action.payload }
                  : laborCode;
              }),
            })),
          })),
        })),
      }));
    },
    editProjectData(state, action) {
      const relevantProject = state.viewSite.projectDetailsList.find(
        ({ projectId }) => projectId === action.payload.projectId.toString(),
      );

      // temporary hack because property is called "projectName" in network request but "name" in local state
      // eventually we need to make it use consistent property name everywhere
      action.payload.name = action.payload.projectName;

      Object.entries(relevantProject).map(([field, value]) => {
        if (action.payload[field] !== undefined && action.payload[field] != value) {
          relevantProject[field] = action.payload[field];
        }
      });
    },
    loadCutSheetsData(state, action) {
      const { projectId, cutSheetData } = action.payload;
      state.viewSite.projectDetailsList = state.viewSite.projectDetailsList.map((proj) => {
        if (proj.projectId !== projectId) {
          return proj;
        }
        return {
          ...proj,
          cutSheetData,
          layerInfoList: proj.layerInfoList.map((layer) => ({
            ...layer,
            rooms: layer.rooms.map((room) => ({
              ...room,
              products: room.products.map((product) => {
                const cutsheet = cutSheetData.find(({ productName }) => productName === product.id);
                const { cutSheetImage, linearLength, layerCutSheetId, rolls } = cutsheet ?? {};

                return {
                  ...product,
                  id: product.id.trim(),
                  layer: layer.layerId,
                  cutSheetImage,
                  linearLength,
                  layerCutSheetId,
                  rollWidth: rolls?.[0]?.width,
                };
              }),
            })),
          })),
        };
      });
    },
    addProduct(state, action) {
      const { projectId, layerId, product } = action.payload;
      const proj = state.viewSite.projectDetailsList.find((proj) => proj.projectId === projectId);
      const layer = proj.layerInfoList.find((l) => l.layerId === layerId);
      const room = (layer?.rooms ?? []).find((room) => room.roomId === product.roomId);
      if (room !== undefined) {
        room.products = [...room.products, product];
      } else {
        layer.rooms = [...layer.rooms, { roomId: product.roomId, products: [product] }];
      }
    },
    deleteRollcut(state, action) {
      const { projectId, rollCutId } = action.payload;
      const proj = state.viewSite.projectDetailsList.find((proj) => proj.projectId === projectId);
      (proj.cutSheetData ?? []).forEach((cutSheet) => {
        (cutSheet.rolls ?? []).forEach((roll) => {
          roll.rollCuts = (roll.rollCuts ?? []).filter((roll) => roll.rollCutId !== rollCutId);
        });
      });
    },
  },
});

export const {
  confirmBulkUpdateModal,
  searchMqProjects,
  searchMqProjectsForEdit,
  searchMqProjectsSucess,
  searchMqProjectForEditSuccess,
  searchIsLoggedInUser,
  updateMqSearchProjectFields,
  getRoomsInfoByMqProjectSuccess,
  setImageData,
  updateSelectLayer,
  updateSelectProject,
  updateSelectAllProjects,
  updateSiteDetailsFields,
  updateEditSiteDetailsFields,
  submitCreateSite,
  searchSites,
  updateSiteSearchFields,
  searchSitesSuccess,
  clearSiteSearchFields,
  clearSiteFields,
  setSiteData,
  setEditSiteData,
  removeLayer,
  resetEditSiteData,
  getLaborCodeList,
  getAllSiteNames,
  setRerunBulkUpdateData,
  loadStoreLaborCodes,
  editSiteProductLaborCode,
  editProjectData,
  loadCutSheetsData,
  addProduct,
  deleteRollcut,
} = siteRepo.actions;

export default siteRepo.reducer;
